<template>
    <div class="range-input-component">
        <div class="row">
            <div class="col-12" style="text-align: center">
                <small>{{ $t('Nível de Praticidade') }}</small>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11">
                <input class="range-input" type="range" disabled :min="min" :max="max" :step="step" :readonly="readonly" :value="value">
            </div>
        </div>

        <div v-if="tickLabels" class="row px-4">
            <div v-for="(label, index) in tickLabels" :key="label" :style="textAlignment(index) + color(index) + 'font-size: 10px;'" :class="`col-${colSize} px-0`">
                {{ label }}
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    props: {
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 100,
        },
        step: {
            type: Number,
            default: 1,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Number,
            default: 0,
        },
        tickLabels: {
            type: Array,
            required: false,
        },
        tickColors: {
            type: Array,
            required: false,
        },
    },
    computed: {
        colSize() {
            return Math.floor(12 / this.tickLabels.length)
        },
    },
    methods: {
        textAlignment(index) {
            const center = Math.ceil(this.tickLabels.length / 2) - 1

            if (index < center) {
                return 'text-align: left;'
            } else if (index > center) {
                return 'text-align: right;'
            } else {
                return 'text-align: center;'
            }
        },
        color(index) {
            if (!this.tickColors) return 'color: #ccc;'

            if (index + 1 != this.value) return 'color: #ccc;'
            
            return `color: ${this.tickColors[index]}; font-weight: bold;`
        }
    }
})

</script>

<style>

input[type=range].range-input {
  width: 100%;
  margin: 6.5px 0;
  background-color: transparent;
  -webkit-appearance: none;
}
input[type=range].range-input:focus {
  outline: none;
}
input[type=range].range-input::-webkit-slider-runnable-track {
  background: linear-gradient(90deg, rgba(255,126,0,1) 0%, rgba(4,156,11,1) 100%);
  border: 0.2px solid rgba(1, 1, 1, 0);
  border-radius: 25px;
  width: 100%;
  height: 5px;
  cursor: default;
}
input[type=range].range-input::-webkit-slider-thumb {
  margin-top: -6.7px;
  width: 14px;
  height: 14px;
  background: #ffffff;
  border: 3.3px solid #d2d2d2;
  border-radius: 20px;
  cursor: default;
  -webkit-appearance: none;
}
input[type=range].range-input:focus::-webkit-slider-runnable-track {
  background: linear-gradient(90deg, rgba(255,126,0,1) 0%, rgba(4,156,11,1) 100%);
}
input[type=range].range-input::-moz-range-track {
  background: linear-gradient(90deg, rgba(255,126,0,1) 0%, rgba(4,156,11,1) 100%);
  border: 0.2px solid rgba(1, 1, 1, 0);
  border-radius: 25px;
  width: 100%;
  height: 5px;
  cursor: default;
}
input[type=range].range-input::-moz-range-thumb {
  width: 14px;
  height: 14px;
  background: #ffffff;
  border: 3.3px solid #d2d2d2;
  border-radius: 20px;
  cursor: default;
}
input[type=range].range-input::-ms-track {
  background: transparent;
  border-color: transparent;
  border-width: 7.4px 0;
  color: transparent;
  width: 100%;
  height: 5px;
  cursor: default;
}
input[type=range].range-input::-ms-fill-lower {
  background: #242424;
  border: 0.2px solid rgba(1, 1, 1, 0);
  border-radius: 50px;
}
input[type=range].range-input::-ms-fill-upper {
  background: linear-gradient(90deg, rgba(255,126,0,1) 0%, rgba(4,156,11,1) 100%);
  border: 0.2px solid rgba(1, 1, 1, 0);
  border-radius: 50px;
}
input[type=range].range-input::-ms-thumb {
  width: 14px;
  height: 14px;
  background: #ffffff;
  border: 3.3px solid #d2d2d2;
  border-radius: 20px;
  cursor: default;
  margin-top: 0px;
  /*Needed to keep the Edge thumb centred*/
}
input[type=range].range-input:focus::-ms-fill-lower {
  background: linear-gradient(90deg, rgba(255,126,0,1) 0%, rgba(4,156,11,1) 100%);
}
input[type=range].range-input:focus::-ms-fill-upper {
  background: linear-gradient(90deg, rgba(255,126,0,1) 0%, rgba(4,156,11,1) 100%);
}
/*TODO: Use one of the selectors from https://stackoverflow.com/a/20541859/7077589 and figure out
how to remove the virtical space around the range input in IE*/
@supports (-ms-ime-align:auto) {
  /* Pre-Chromium Edge only styles, selector taken from hhttps://stackoverflow.com/a/32202953/7077589 */
  input[type=range].range-input {
    margin: 0;
    /*Edge starts the margin from the thumb, not the track as other browsers do*/
  }
}

</style>
